// PINE tunnel animation

// Constants
const LOOPS = 10;
const TUNNEL_REPETITIONS = 3;
const TUNNEL_LENGTH = 500;
const TUNNEL_RADIUS = 10;
const CAMERA_FOV = 75;
const CAMERA_NEAR = 0.1;
const CAMERA_FAR = 2000;
const TUBULAR_SEGMENTS = 600;
const RADIAL_SEGMENTS = 128;
const ROTATION_SPEED = 0.1;
const MOVEMENT_SPEED = 0.01;

// Initialize Scene, Camera, and Renderer
const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(
  CAMERA_FOV,
  window.innerWidth / window.innerHeight,
  CAMERA_NEAR,
  CAMERA_FAR
);
const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
renderer.setPixelRatio(window.devicePixelRatio);
renderer.setSize(window.innerWidth, window.innerHeight);
document.getElementById('background-tunnel').appendChild(renderer.domElement);

// Custom Twist Curve
class CustomTwistCurve extends THREE.Curve {
  constructor(scale = 1, loops = LOOPS) {
    super();
    this.scale = scale;
    this.loops = loops;
  }

  getPoint(t, optionalTarget = new THREE.Vector3()) {
    const angle = t * Math.PI * 2 * this.loops;
    const x = Math.cos(angle) * TUNNEL_RADIUS;
    const y = Math.sin(angle) * TUNNEL_RADIUS;
    const z = t * TUNNEL_LENGTH;
    return optionalTarget.set(x, y, z).multiplyScalar(this.scale);
  }
}

// Create Tunnel Geometry
const path = new CustomTwistCurve(1, LOOPS);
const geometry = new THREE.TubeGeometry(
  path,
  TUBULAR_SEGMENTS,
  TUNNEL_RADIUS,
  RADIAL_SEGMENTS,
  false
);
const frames = path.computeFrenetFrames(TUBULAR_SEGMENTS, false);

// Load Texture
const textureLoader = new THREE.TextureLoader();
const textureURL =
  '//z2g0hrgcndpwnot5-7535007.shopifypreview.com/cdn/shop/t/3/assets/PINE.png?v=80992656622787981901727983399';

textureLoader.load(
  textureURL,
  startScene,
  undefined,
  (err) => console.error('Error loading texture:', err)
);

function startScene(texture) {
  if (!texture.image) {
    console.error('Texture image not available.');
    return;
  }

  setupTexture(texture);
  const material = new THREE.MeshBasicMaterial({
    map: texture,
    side: THREE.BackSide,
  });
  const tunnelGroup = createTunnelGroup(material);
  scene.add(tunnelGroup);

  const clock = new THREE.Clock();
  animate(clock, tunnelGroup);
}

function setupTexture(texture) {
  texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
  texture.magFilter = THREE.LinearFilter;
  texture.minFilter = THREE.LinearMipMapLinearFilter;
  texture.generateMipmaps = true;
  texture.anisotropy = renderer.capabilities.getMaxAnisotropy();

  const repeatsU = RADIAL_SEGMENTS / 4;
  const repeatsV = LOOPS * 0.5;
  texture.repeat.set(repeatsU, repeatsV);
}

function createTunnelGroup(material) {
  const tunnelGroup = new THREE.Group();
  const tunnel = new THREE.Mesh(geometry, material);
  for (let i = 0; i < TUNNEL_REPETITIONS; i++) {
    const tunnelInstance = tunnel.clone();
    tunnelInstance.position.z = -i * TUNNEL_LENGTH;
    tunnelGroup.add(tunnelInstance);
  }
  return tunnelGroup;
}

let progress = 0;
const tempVector = new THREE.Vector3();
const tempQuaternion = new THREE.Quaternion();

function animate(clock, tunnelGroup) {
  requestAnimationFrame(() => animate(clock, tunnelGroup));

  progress += MOVEMENT_SPEED * clock.getDelta();

  if (progress >= 0.87) {
    progress = 0;
    tunnelGroup.position.z += TUNNEL_LENGTH;
  }

  updateCameraPosition(progress, clock.elapsedTime, tunnelGroup.position.z);
  renderer.render(scene, camera);
}

function updateCameraPosition(progress, elapsedTime, tunnelOffsetZ) {
  const progressMod = progress % 1;
  const positionInSegments = progressMod * TUBULAR_SEGMENTS;
  const index = Math.floor(positionInSegments);
  const lerpAmount = positionInSegments - index;

  const tangent = frames.tangents[index].clone().lerp(
    frames.tangents[(index + 1) % frames.tangents.length],
    lerpAmount
  ).normalize();
  const normal = frames.normals[index].clone().lerp(
    frames.normals[(index + 1) % frames.normals.length],
    lerpAmount
  ).normalize();

  const rollAngle = elapsedTime * ROTATION_SPEED * Math.PI * 2;
  tempQuaternion.setFromAxisAngle(tangent, rollAngle);
  normal.applyQuaternion(tempQuaternion);

  camera.up.copy(normal);
  path.getPointAt(progressMod, tempVector);
  tempVector.z += tunnelOffsetZ;
  camera.position.copy(tempVector);
  camera.lookAt(tempVector.add(tangent));
}

window.addEventListener('resize', () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  renderer.setSize(width, height);
  camera.aspect = width / height;
  camera.updateProjectionMatrix();
});